module.exports = {
  TENANT: 'tenant',
  OWNER_WITH_MORTGAGE: 'owner-with-mortgage',
  OWNER: 'owner',
  HOUSING_BY_FAMILY: 'housing-by-family',
  HOUSING_BY_EMPLOYER: 'housing-by-employer',
};
